import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _Object$values from '@babel/runtime-corejs3/core-js-stable/object/values';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import React__default, { useState, useContext, useCallback, useMemo } from 'react';
import '../../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import usePrevious from '../../../hooks/usePrevious/9c6157d26fdef2615304320d8b4c13dc98613f4887bdbf3ba75408f64b4d1ccc.cfe-internal.js';
import useSSRLayoutEffect from '../../../hooks/useSSRLayoutEffect/1b5a8c3b5463c14b01e195c9e403e1d1bbb3a66e0ef365e78fe012b249d635d1.cfe-internal.js';

var _excluded = ["element", "index"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context6, _context7; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context6 = ownKeys(Object(t), !0)).call(_context6, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context7 = ownKeys(Object(t))).call(_context7, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * This hook registers our descendant by passing it into an array. We can then
 * search that array by to find its index when registering it in the component.
 * We use this for focus management, keyboard navigation, and typeahead
 * functionality for some components.
 *
 * The hook accepts the element node and (optionally) a key. The key is useful
 * if multiple descendants have identical text values and we need to
 * differentiate siblings for some reason.
 *
 * Our main goals with this are:
 *   1) maximum composability,
 *   2) minimal API friction
 *   3) SSR compatibility*
 *   4) concurrent safe
 *   5) index always up-to-date with the tree despite changes
 *   6) works with memoization of any component in the tree (hopefully)
 *
 * * As for SSR, the good news is that we don't actually need the index on the
 * server for most use-cases, as we are only using it to determine the order of
 * composed descendants for keyboard navigation. However, in the few cases where
 * this is not the case, we can require an explicit index from the app.
 */
function useDescendant(descendant, context, indexProp) {
  var _context;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    forceUpdate = _useState2[1];
  var _useContext = useContext(context),
    registerDescendant = _useContext.registerDescendant,
    unregisterDescendant = _useContext.unregisterDescendant,
    descendants = _useContext.descendants;

  // This will initially return -1 because we haven't registered the descendant
  // on the first render. After we register, this will then return the correct
  // index on the following render and we will re-register descendants
  // so that everything is up-to-date before the user interacts with a
  // collection.
  var index = indexProp !== null && indexProp !== void 0 ? indexProp : _findIndexInstanceProperty(descendants).call(descendants, function (item) {
    return item.element === descendant.element;
  });
  var previousDescendants = usePrevious(descendants);

  // We also need to re-register descendants any time ANY of the other
  // descendants have changed. My brain was melting when I wrote this and it
  // feels a little off, but checking in render and using the result in the
  // effect's dependency array works well enough.
  var someDescendantsHaveChanged = _someInstanceProperty(descendants).call(descendants, function (descendant, index) {
    var _previousDescendants$;
    return descendant.element !== (previousDescendants === null || previousDescendants === void 0 || (_previousDescendants$ = previousDescendants[index]) === null || _previousDescendants$ === void 0 ? void 0 : _previousDescendants$.element);
  });

  // Prevent any flashing
  useSSRLayoutEffect(function () {
    if (!descendant.element) forceUpdate({});
    registerDescendant(_objectSpread(_objectSpread({}, descendant), {}, {
      index: index
    }));
    return function () {
      return unregisterDescendant(descendant.element);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, _concatInstanceProperty(_context = [registerDescendant, unregisterDescendant, index, someDescendantsHaveChanged]).call(_context, _toConsumableArray(_Object$values(descendant))));
  return index;
}
function useDescendants(ctx) {
  return useContext(ctx).descendants;
}
function DescendantProvider(_ref) {
  var Ctx = _ref.context,
    children = _ref.children,
    items = _ref.items,
    set = _ref.set;
  var registerDescendant = useCallback(function (_ref2) {
    var element = _ref2.element,
      explicitIndex = _ref2.index,
      rest = _objectWithoutProperties(_ref2, _excluded);
    if (!element) {
      return;
    }

    // eslint-disable-next-line no-shadow
    set(function (items) {
      var newItems;
      if (explicitIndex != null) {
        var _context2;
        newItems = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(items), [_objectSpread(_objectSpread({}, rest), {}, {
          element: element,
          index: explicitIndex
        })]);
      } else if (items.length === 0) {
        var _context3;
        // If there are no items, register at index 0 and bail.
        newItems = _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(items), [_objectSpread(_objectSpread({}, rest), {}, {
          element: element,
          index: 0
        })]);
      } else if (_findInstanceProperty(items).call(items, function (item) {
        return item.element === element;
      })) {
        // If the element is already registered, just use the same array
        newItems = items;
      } else {
        // When registering a descendant, we need to make sure we insert in
        // into the array in the same order that it appears in the DOM. So as
        // new descendants are added or maybe some are removed, we always know
        // that the array is up-to-date and correct.
        //
        // So here we look at our registered descendants and see if the new
        // element we are adding appears earlier than an existing descendant's
        // DOM node via `node.compareDocumentPosition`. If it does, we insert
        // the new element at this index. Because `registerDescendant` will be
        // called in an effect every time the descendants state value changes,
        // we should be sure that this index is accurate when descendent
        // elements come or go from our component.
        var index = _findIndexInstanceProperty(items).call(items, function (item) {
          if (!item.element || !element) {
            return false;
          }
          // Does this element's DOM node appear before another item in the
          // array in our DOM tree? If so, return true to grab the index at
          // this point in the array so we know where to insert the new
          // element.
          return Boolean(
          // eslint-disable-next-line no-bitwise
          item.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING);
        });
        var newItem = _objectSpread(_objectSpread({}, rest), {}, {
          element: element,
          index: index
        });

        // If an index is not found we will push the element to the end.
        if (index === -1) {
          var _context4;
          newItems = _concatInstanceProperty(_context4 = []).call(_context4, _toConsumableArray(items), [newItem]);
        } else {
          var _context5;
          newItems = _concatInstanceProperty(_context5 = []).call(_context5, _toConsumableArray(_sliceInstanceProperty(items).call(items, 0, index)), [newItem], _toConsumableArray(_sliceInstanceProperty(items).call(items, index)));
        }
      }
      return _mapInstanceProperty(newItems).call(newItems, function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          index: index
        });
      });
    });
  },
  // set is a state setter initialized by the useDescendants hook.
  // We can safely ignore the lint warning here because it will not change
  // between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var unregisterDescendant = useCallback(function (element) {
    if (!element) {
      return;
    }

    // eslint-disable-next-line no-shadow
    set(function (items) {
      return _filterInstanceProperty(items).call(items, function (item) {
        return element !== item.element;
      });
    });
  },
  // set is a state setter initialized by the useDescendants hook.
  // We can safely ignore the lint warning here because it will not change
  // between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return /*#__PURE__*/React__default.createElement(Ctx.Provider, {
    value: useMemo(function () {
      return {
        descendants: items,
        registerDescendant: registerDescendant,
        unregisterDescendant: unregisterDescendant
      };
    }, [items, registerDescendant, unregisterDescendant])
  }, children);
}

export { DescendantProvider, useDescendant, useDescendants };
